module.exports = __webpack_public_path__ + "static/karol.33d5b3e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/karol.jpg
// module id = 154
// module chunks = 35783957827783 114276838955818